import { useAppSelector } from 'store/hooks';
import { Image } from '@skf-internal/ui-components-react-legacy';

const BearingTypeImage = () => {
  const currentBearingTypeImage = useAppSelector((state) => state.input.bearingType.image);
  return <Image className="mx-auto pt-6 sm:pt-9 w-8/12 sm:w-6/12" src={currentBearingTypeImage} feObjectFit="scale-down" alt="" />;
};

export default BearingTypeImage;
